import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from 'react-router-dom'
import axios from 'axios'
import { connectNode } from '../../../../utils/global'
import { loadLocationWithMessage } from '../../../../actions/location'
import Button from '@material-ui/core/Button'
import WarningIcon from '@material-ui/icons/Warning'
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import '../../../../styles/assets/css/pages/additional_program.css'
import { initAutosaveForForm, ensureAutosaveInitialized, detachAutosave } from '../../../utils/draftAutosaveManager'

class HM_module1 extends Component {
  constructor(props) {
    super(props)
    this.state = {
      status: 1, // 1: editable, 2: completed, 3: past/read-only
      message: '',
      saving: false,
      mood: -1,
      energy_activation: -1,
      attention: -1,
      planning: -1,
      decision_making: -1,
      what_happened: '',
      mood_connected: -1, // 1: No, 2: Yes, 3: Maybe, 4: Unsure
      start_time: Math.floor(new Date().getTime()/1000),
      start_datetime: new Date().toLocaleString('en-US', { hour12: false }).slice(0, 19).replace('T', ' '),
    }
    this.answerFields = ['mood', 'energy_activation', 'attention', 'planning', 'decision_making', 'what_happened', 'mood_connected']
    this._draft = null
  }

  componentDidMount() {
    this._draft = initAutosaveForForm(this, {
      formId: 'hm_module1',
      fields: this.answerFields,
      expireMs: 10 * 24 * 60 * 60 * 1000,
    })
    this.getHomeworkProcess()
  }

  componentDidUpdate(prevProps) {
    ensureAutosaveInitialized(this, '_draft', {
      formId: 'hm_module1',
      fields: this.answerFields,
      expireMs: 10 * 24 * 60 * 60 * 1000,
    }, prevProps)
  }

  componentWillUnmount() {
    detachAutosave(this, '_draft')
  }

  /*getHomeworkProcess = async () => {
    if (!this.props.verifyHomework) return
    try {
      // Expected: { allowed: true, status: 1|2|3, answers?: {...} }
      const result = await this.props.verifyHomework()
      if (!result || result.allowed === false) {
        this.setState({ status: 3, message: 'This homework is not available.' })
        return
      }
      if (result.status > 1) {
        // Do not restore a draft over completed server answers.
        if (this._draft) this._draft.clear()
        const answers = result.answers || (this.props.getCompletedData ? await this.props.getCompletedData() : {})
        const saved = {}
        this.answerFields.forEach(field => {
          if (answers && answers[field] != null) saved[field] = answers[field]
        })
        this.setState({ ...saved, status: result.status })
      }
    } catch (error) {
      console.error('Unable to verify Module 1 homework:', error)
      this.setState({ status: 3, message: 'Unable to verify homework availability. Please try again.' })
    }
  }*/


  getHomeworkProcess = () => {
    axios({
      method: 'post',
      url: connectNode + 'patient/additional_program/get_efc_module1',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: {
        pid: this.props.authReducer.uid,
        timepoint_type: 'd',
        timepoint: Number(this.props.match.params.day),
      }
    })
    .then((result) => {
      const data = result.data

      if (data && data.id && Number(data.status) === 1) {
        // Homework already submitted
        if (this._draft) this._draft.clear()

        const saved = {}

        this.answerFields.forEach(field => {
          if (data[field] != null) {
            saved[field] = field === 'what_happened'
              ? data[field]
              : Number(data[field])
          }
        })

        this.setState({
          ...saved,
          status: 2,
          message: ''
        })
      } else {
        // Homework not submitted yet
        this.setState({
          status: 1,
          message: ''
        })
      }
    })
    .catch((error) => {
      console.error('Unable to get Module 1 homework:', error)

      this.setState({
        status: 3,
        message: 'Unable to load homework. Please try again.'
      })
    })
  }


  handleChange = (e) => {
    if (this.state.status !== 1) return
    const name = e.target.name
    const value = name === 'what_happened' ? e.target.value : Number(e.target.value)
    this.setState({ [name]: value, message: '' }, () => {
      if (this._draft) this._draft.savePartial(name, value, this.state)
    })
  }

  handleSubmit = async (e) => {
    e.preventDefault()
    if (this.state.status !== 1 || this.state.saving) return
    const s = this.state
    const required = ['mood', 'energy_activation', 'attention', 'planning', 'decision_making', 'mood_connected']
    const hasDifficulty = s.attention === 1 || s.planning === 1 || s.decision_making === 1
    if (required.some(field => s[field] === -1) || (hasDifficulty && !s.what_happened.trim())) {
      this.setState({ message: 'Please complete all questions before submitting your homework.' })
      window.scrollTo(0, 0)
      return
    }

    this.setState({ saving: true, message: '' })

    axios({
      method: 'post',
      url: connectNode + 'patient/additional_program/add_efc_module1',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: {
        pid: this.props.authReducer.uid,
        user: this.state,
        timepoint_type: 'd',
        timepoint: this.props.match.params.day,
      }
    })
    .then((result) => {
      console.log(result['data'])
      if (result['data'] && result['data'] === 'complete_efc_module1') {
        if (this._draft) this._draft.clear()

        this.setState({
          status: 2,
          saving: false,
          message: ''
        })
        this.props.onLoadLocation('/member/efc/coaching_material_list', 'Thank you for completing your Daily Mood–Thinking Check.')
        this.props.history.push('/member/efc/coaching_material_list')
      } else {
        this.setState({
          saving: false,
          message: 'Unable to save homework. Please try again.'
        })
      }
    })
    .catch((error) => {
      console.error('Module 1 homework save failed:', error)
      this.setState({
        saving: false,
        message: 'Unable to save homework. Please try again.'
      })
    })
  }

  renderScale = (field, label, description) => (
    <div className="row" style={{ marginBottom: 24 }}>
      <div className="small-12 columns">
        <b>{label}</b> - {description}
      </div>
      <div className="small-12 columns">
        <div style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          marginTop: 12
        }}>
          {Array.from({ length: 11 }, (_, i) => (
            <label
              key={field + i}
              style={{
                width: '16.66%',
                maxWidth: 65,
                textAlign: 'center',
                cursor: 'pointer',
                fontSize: 12,
                marginBottom: 12
              }}
            >
              <input
                type="radio"
                name={field}
                value={i}
                checked={this.state[field] === i}
                disabled={this.state.status > 1}
                onChange={this.handleChange}
                style={{
                  display: 'block',
                  margin: '0 auto 5px'
                }}
              />
              <span>{i}</span>
              <div style={{ fontSize: 10, fontWeight: 'bold' }}>
                {i === 0 ? 'Low' :
                 i === 5 ? 'Baseline' :
                 i === 10 ? 'High' : '\u00a0'}
              </div>
            </label>
          ))}
        </div>
      </div>
    </div>
  )

  renderYesNo = (field, label) => (
    <div className="row" style={{ marginBottom: 12 }}>
      <div className="small-12 columns"><b>{label}</b></div>
      {[{ value: 0, label: 'No' }, { value: 1, label: 'Yes' }].map(option => (
        <div className="small-6 medium-3 columns float_left" key={field + option.value}>
          <label><input type="radio" name={field} value={option.value}
            checked={this.state[field] === option.value}
            disabled={this.state.status > 1} onChange={this.handleChange} /> {option.label}</label>
        </div>
      ))}
    </div>
  )

  render() {
    const s = this.state
    const hasDifficulty = s.attention === 1 || s.planning === 1 || s.decision_making === 1
    return (
      <div className="assm_hm_module1 box_border4">
        <div className="row"><div className="small-12 columns headerPage1">
          <span className="orange1">Module 1:</span> Understanding Executive Functioning and Bipolar Disorder
        </div></div>
        {s.message !== '' && <div className="row warning_msg6"><div className="small-12 columns">
          <div className="float_left1"><WarningIcon /></div>
          <div className="txt_warning_msg1">{s.message}</div>
        </div></div>}
        <form onSubmit={this.handleSubmit}>
          <div className="row">
            <div className="small-12 columns mod_1">
              <div className="hm_header1">Homework: Daily Mood–Thinking Check</div>
              <div className="instruction1">Complete this worksheet once per day.</div>
              <div className="box1">
                {this.renderScale('mood', 'Mood', 'Rate your mood on a scale of 0–10, with 5 reflecting your baseline.')}
                {this.renderScale('energy_activation', 'Energy/activation', 'Rate your energy on a scale of 0–10, with 5 reflecting your baseline.')}
              </div>
              <div className="sep_line1">&nbsp;</div>
              <div className="hm_header2">Today, did I notice difficulty with:</div>
              <div className="box1">
                <div className="row">
                  <div className="small-12 medium-6 columns">
                  {this.renderYesNo('attention', 'Attention?')}
                  {this.renderYesNo('planning', 'Planning?')}
                  {this.renderYesNo('decision_making', 'Decision-making?')}
                  </div>
                  <div className="small-12 medium-6 columns align_center">
                    <p className="orange1 bold box2"><NotificationsActiveIcon /><br />Don't try to fix the problem yet. Just notice it and write it down.</p>
                  </div>
                </div>
              </div>

              <div className="sep_line3">&nbsp;</div>
              <div className="row"><div className="small-12 columns">
                <label><b>If yes, what happened?</b></label>
                <textarea name="what_happened" rows="4" value={s.what_happened}
                  disabled={s.status > 1} onChange={this.handleChange}
                  style={{ width: '100%' }} />
              </div></div>
              <div className="sep_line3">&nbsp;</div>
              <div className="row"><div className="small-12 columns"><b>Did my mood seem connected to it?</b></div>
                {[{ value: 1, label: 'No' }, { value: 2, label: 'Yes' },
                  { value: 3, label: 'Maybe' }, { value: 4, label: 'Unsure' }].map(option => (
                  <div className="small-6 medium-3 columns" key={'connected_' + option.value}>
                    <label><input type="radio" name="mood_connected" value={option.value}
                      checked={s.mood_connected === option.value}
                      disabled={s.status > 1} onChange={this.handleChange} /> {option.label}</label>
                  </div>
                ))}
              </div>
            </div>
            <div className="small-12 columns align_right top_space1">
              {s.status === 1 && <Button variant="contained" color="primary" disableElevation
                type="submit" className="submit_1" disabled={s.saving}>
                {s.saving ? 'Saving...' : 'Submit'}
              </Button>}
              {s.status > 1 && <span>Completed (read-only)</span>}
            </div>
          </div>
        </form>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return state
}

const mapDispatchToProps = (dispatch) => ({
  onLoadPages(response) {
    dispatch({
      type: 'LOAD_USER_AUTH',
      payload: response,
    })
  },
  onLoadLocation(route, msg) {
    dispatch(loadLocationWithMessage(route, msg))
  },
})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(HM_module1)
